import type { AdditionalParams } from '@mimir/common/util/apiClient';
import { getPath } from '@mimir/common/util/getPath';
import type { BackendClient } from '@mimir/common/util/backendClient';
import { unknownBody } from '@mimir/common/client/assumeResult';
import type { ApiCommand } from '@mimir/common/api/apiCommand';

export async function callApiCommand<OutputType>(c: BackendClient, command: ApiCommand<OutputType>, additionalParams: AdditionalParams | undefined): Promise<OutputType> {
  const req = command.request();
  const params: AdditionalParams = { ...additionalParams };
  if (req.queryParams) {
    if (!params.queryParams) {
      params.queryParams = req.queryParams;
    } else {
      params.queryParams = { ...params.queryParams, ...req.queryParams };
    }
  }
  const result = await c.getApiClient().call(getPath(c.getServiceLinks()[req.linkName], req.pathParams), req.method, params, req.body);
  return command.asOutput(unknownBody(result));
}
